import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DropdownMenu from "../atoms/DropdownMenu";
import { DateRangePicker } from "./DateRangePicker";

interface MissionSearchFormProps {
  selectedType: string;
  selectedStartDate: Date | null;
  selectedEndDate: Date | null;
  onTypeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onSearch: () => void;
}

const currencies = [
  { value: "", label: "" },
  { value: "019372c6-c935-7261-8955-f55c1b7d9ff2", label: "アプリ起動" },
  {
    value: "019372c6-c935-732d-b4cc-889b56cd7857",
    label: "電気代シミュレーション",
  },
  { value: "019372c6-c935-737e-b37c-c34141af61be", label: "積算充電量" },
  { value: "019372c6-c935-72c6-ab12-e352aba76fac", label: "記事閲覧" },
];

export const MissionSearchForm: React.FC<MissionSearchFormProps> = ({
  selectedType,
  selectedStartDate,
  selectedEndDate,
  onTypeChange,
  onStartDateChange,
  onEndDateChange,
  onSearch,
}) => {
  // const [startError, setStartError] = useState<string | null>(null);
  // const [endError, setEndError] = useState<string | null>(null);

  const validateForm = () => {
    if (
      selectedStartDate &&
      selectedEndDate &&
      selectedStartDate > selectedEndDate
    ) {
      onEndDateChange(null);
    } else {
    }
  };

  useEffect(() => {
    validateForm();
  }, [selectedStartDate, selectedEndDate]);

  return (
    <Box
      display="flex"
      gap={3}
      alignItems="flex-start"
      sx={{ fontSize: "0.75rem" }}
    >
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          ミッションタイプ
        </Typography>
        <DropdownMenu
          label="タイプ"
          value={selectedType}
          onChange={onTypeChange}
          options={currencies}
        />
      </Box>
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          配信期間の指定
        </Typography>
        <DateRangePicker
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onStartChange={onStartDateChange}
          onEndChange={onEndDateChange}
          // startError={!!startError}
          // endError={!!endError}
          // startHelperText={startError ?? " "}
          // endHelperText={endError ?? " "}
        />
      </Box>
      <></>

      <Box sx={{ marginTop: "35px" }}>
        <Button variant="outlined" onClick={onSearch}>
          検索
        </Button>
      </Box>
    </Box>
  );
};
